export const GET_USER = 'GET_USER'
export const GET_TEAM_USER = 'GET_TEAM_USER'
export const GET_USERS_TASK_ARE_ASSIGNED_TO = 'GET_USERS_TASK_ARE_ASSIGNED_TO'
export const GET_ALL_USERS = 'GET_ALL_USERS'
export const UPDATE_USER = 'UPDATE_USER'
export const DELETE_USER = 'DELETE_USER'
export const CREATE_USER = 'CREATE_USER'
export const RESET_USER = 'RESET_USER'
export const SET_PROFILE_IMAGE = 'SET_PROFILE_IMAGE'
export const GET_PROFILE_IMAGE = 'GET_PROFILE_IMAGE'
export const GET_TEAMUSER_PROFILE_IMAGE = 'GET_TEAMUSER_PROFILE_IMAGE'
export const GET_PROFILE_IMAGE_CURRENT_USER = 'GET_PROFILE_IMAGE_CURRENT_USER'
export const RESET_TEAMUSER = 'RESET_TEAMUSER'
export const GET_USERS_SIGNATURE = 'GET_USERS_SIGNATURE'
export const SET_USER_SIGNATURE = 'SET_USER_SIGNATURE'
export const RESET_SIGNATURE = 'RESET_SIGNATURE'
export const GET_USERS_FOR_DROPDOWN = 'GET_USERS_FOR_DROPDOWN'
export const GET_USERS_EXPECTATIONS = 'GET_USERS_EXPECTATIONS'
export const CHANGE_USERS_EXPECTATIONS = 'CHANGE_USERS_EXPECTATIONS'
export const SET_USERS_FOR_CUSTOM_SELECT = 'SET_USERS_FOR_CUSTOM_SELECT'
export const GET_USER_RATING = 'GET_USER_RATING'
export const GET_USERS_FOR_SELECT = 'GET_USERS_FOR_SELECT'
export const GET_MY_TEAM = 'GET_MY_TEAM'
export const DECRYPT = 'DECRYPT'
export const GET_USER_OPTIONS = 'GET_USER_OPTIONS'
export const UPDATE_USER_OPTIONS = 'UPDATE_USER_OPTIONS'
